import React from "react";
import HthTeamContainer from "./HthTeamContainer";
import {FormattedMessage} from "react-intl";


class HeadToHead extends React.PureComponent {

    render() {
        return <div ref={(ref) => {
            this.selfNode = ref;
        }} className="head-to-head clearfix">
            <h2 className="head-to-head__title"><FormattedMessage id="hth.title"/></h2>
            <div className="head-to-head__team head-to-head__team--left"><HthTeamContainer position="left"/></div>
            <div className="head-to-head__team head-to-head__team--right"><HthTeamContainer position="right"/></div>
        </div>
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.show && this.props.show) {
            this.ensureVisible();
        }
    }

    componentDidMount() {
        if (this.props.show) {
            this.ensureVisible();
        }
    }

    ensureVisible() {
        if (this.selfNode) {
            this.selfNode.scrollIntoView();
        }
    }
}

export default HeadToHead;